/*!
 * Copyright 2022 Quisitive Technologies, LLC. All rights reserved.
 */
/* eslint-disable react/no-unescaped-entities */
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { get, find, size } from 'lodash';
import React, { Component, Fragment } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { ASSESSMENTS_URL, VISIT_URL } from '../../api/endpoints';
import ConsentNoIcon from '../../assets/icons/consent_no.svg';
import ConsentYesIcon from '../../assets/icons/consent_yes.svg';
import LogoBlack from '../../assets/icons/logo-black.svg';
import ConfirmationIcon from '../../assets/icons/visit_confirmation.svg';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';
import {
  apiRequest,
  changeRoute,
  getUserFromDBAndUpdateStore,
  highlightNavbarSection,
  setActiveAssessment,
  setActiveAssessments,
  setActiveVisit,
  setProgressBarPercent,
  setUpcomingVisitAssessmentsNotice,
  sortNav
} from '../../root/actions';
import { dispatch } from '../../root/store';
import { cleanAssessments } from '../../utils';
import Survey from './FormComponent/index';
import style from './style';

export class Assessment extends Component {
  state = {
    surveyClass: 'site-view survey-view',
    isShowModal: false,
    isUpdatingAssessment: false,
    isShowPreConsent: true,
    isSubmitting: false
  };

  gotoAssessments() {
    const visitId = this.props.activeVisit.uuid;
    const route = `/visits/${visitId}/assessments`;

    dispatch(changeRoute({ route }));

    const siteView = document.querySelector('.site-view');
    if (siteView) siteView.scrollTop = 0;
  }

  componentDidUpdate() {
    // const { visitId, assessmentId, assessmentPage } = this.props.match.params;
    // if (visitId && assessmentId) {
    //   const route = `/visits/${visitId}/assessments/${assessmentId}`;
    //   if (assessmentId === 'consent' && !assessmentPage) {
    //     dispatch(changeRoute({ route: `${route}/intro` }));
    //   }
    // }
    // if (this.props.activeAssessment) {
    //   this.setSidebar();
    //   if (
    //     this.props.activeAssessment.shortName !== assessmentId &&
    //     !this.state.isUpdatingAssessment
    //   ) {
    //     this.setState({ isUpdatingAssessment: true }, () =>
    //       this.refreshAssessment()
    //     );
    //   }
    // }
  }

  setSidebar() {
    if (this.props.activeAssessment !== null) {
      if (this.props.activeAssessment.shortName === 'consent') {
        dispatch(highlightNavbarSection('currentReport'));
      } else {
        if (this.isNewAssessmentsWithHistory()) {
          dispatch(highlightNavbarSection('upcomingVisit'));
        } else {
          dispatch(highlightNavbarSection('history'));
        }
      }
    }
  }

  isNewAssessmentsWithHistory() {
    if (this.props.activeAssessment === null) return;

    const uuid = this.props.activeAssessment._meta.visitId;
    const hasVisitPassed = find(this.props.pastVisits, { uuid });
    const hasCompletedVisits = size(this.props.pastVisits) >= 1;

    return hasVisitPassed === undefined && hasCompletedVisits;
  }

  isVisitLoaded() {
    return (
      this.props.activeVisit &&
      this.props.activeVisit.uuid === this.props.match.params.visitId
    );
  }

  isAssessmentLoaded() {
    return this.props.activeAssessments && this.props.activeAssessment;
  }

  isCorrectAssessmentLoaded() {
    return (
      this.props.activeAssessment &&
      this.props.activeAssessment.shortName ===
      this.props.match.params.assessmentId
    );
  }

  refreshAssessment() {
    const { visitId, assessmentId, assessmentPage } = this.props.match.params;

    // assessmentPage is a subroute of an assessment route

    if (!this.isVisitLoaded() || !this.isAssessmentLoaded()) {
      const request = {
        url: `${VISIT_URL}/${visitId}`,
        method: 'get'
      };

      const activeVisitMeta = {
        setActiveAssessment: true,
        activeAssessment: assessmentId,
        onSuccess: (result, meta) => {
          const { activeAssessment } = meta;
          const route = `/visits/${visitId}/assessments/${assessmentId}`;

          this.setState({ isUpdatingAssessment: false });

          if (this.props.activeAssessment) {
            dispatch(
              setProgressBarPercent(this.props.activeAssessment.percent)
            );
            this.setSidebar();
          }

          if (assessmentId === 'consent' && !assessmentPage) {
            dispatch(changeRoute({ route: `${route}/intro` }));
          } else if (assessmentPage && activeAssessment) {
            const progress = this.props.activeAssessment.progress;
            const subRoute = this.props.activeAssessment.questions[progress]
              .subRoute.route;

            if (assessmentPage === subRoute) return;
            dispatch(changeRoute({ route: `${route}${subRoute}` }));
          }
        }
      };

      const meta = {
        Component: 'Assessment',
        assert: {
          item: visitId,
          test: 'isString'
        },
        onSuccess: result => dispatch(setActiveVisit(result, activeVisitMeta))
      };

      dispatch(apiRequest(request, meta));
    } else if (!this.isCorrectAssessmentLoaded() || this.isVisitLoaded()) {
      this.setState({ isUpdatingAssessment: false });

      dispatch(setActiveAssessment(this.props.activeAssessments[assessmentId]));

      if (this.props.activeAssessments[assessmentId]) {
        dispatch(
          setProgressBarPercent(
            this.props.activeAssessments[assessmentId].percent
          )
        );
        this.setSidebar();
      }

      const route = `/visits/${visitId}/assessments/${assessmentId}`;

      const isBeginningConsent = assessmentId === 'consent' && !assessmentPage;

      if (isBeginningConsent) {
        dispatch(changeRoute({ route: `${route}/intro` }));
      } else if (assessmentPage) {
        // If there there are subroutes to an assessment go through those.
        const progress = this.props.activeAssessments[assessmentId].progress;
        const subRoute = this.props.activeAssessments[assessmentId].questions[
          progress
        ].subRoute.route;

        if (assessmentPage === subRoute) return;
        dispatch(changeRoute({ route: `${route}${subRoute}` }));
      }
    }
    setTimeout(() => this.setSidebar(), 200);
  }

  UNSAFE_componentWillMount() {
    // this.refreshAssessment();
  }

  componentWillUnmount() {
    dispatch(setProgressBarPercent(0));
  }

  editSurveyData = (
    surveyData,
    shouldPutData,
    callback,
    submitSingleSurvey,
    singleSurveyRoute,
    singleSurveyData,
    shortName
  ) => {
    const cleanSurveyData = cleanAssessments(surveyData);
    dispatch(sortNav());
    // If consent assessment, show assessments notice

    if (submitSingleSurvey) {
      if (this.state.isSubmitting) return;
      this.setState({ isSubmitting: true });
      dispatch(setUpcomingVisitAssessmentsNotice(false));
      const request = {
        method: 'put',
        url: singleSurveyRoute,
        data: singleSurveyData
      };
      const meta = {
        Component: 'Assessment',
        onError: () => this.setState({ isSubmitting: false }),
        onSuccess: result => {
          if (shortName && shortName === 'consent') {
            this.setState({ isShowModal: true });
            dispatch(getUserFromDBAndUpdateStore({ Component: 'Assessment' }));
          } else {
            const nextAssessment = find(surveyData, { completed: false });
            if (nextAssessment !== undefined) {
              dispatch(setActiveAssessment(nextAssessment));
              dispatch(changeRoute({ route: nextAssessment._meta.route }));
            } else {
              if (this.isNewAssessmentsWithHistory()) {
                const assessmentNumber = this.props.activeAssessment.order;
                let route = null;

                if (
                  assessmentNumber <
                  size(this.props.activeAssessments) - 1
                ) {
                  // dont count consent
                  const upcomingAssessment = find(
                    this.props.activeAssessments,
                    {
                      order: assessmentNumber + 1
                    }
                  );
                  route = get(upcomingAssessment, '_meta.route');
                } else route = '/';

                dispatch(changeRoute({ route }));
              } else {
                dispatch(changeRoute({ route: '/' }));
                dispatch(highlightNavbarSection('upcomingVisit'));
              }
            }
          }
          if (callback) callback(surveyData);
          this.setState({ isSubmitting: false });
        }
      };
      if (singleSurveyRoute === '/me/assessment/sleep') {
        if (
          !(
            singleSurveyData.enthusiasm === '' &&
            singleSurveyData.sleepMedication === '' &&
            singleSurveyData.sleepQuality === '' &&
            singleSurveyData.stayingAwake === ''
          )
        ) {
          dispatch(apiRequest(request, meta));
        }
      } else {
        dispatch(apiRequest(request, meta));
      }
    }
    if (shouldPutData) {
      dispatch(setActiveAssessments(surveyData));
    } else {
      if (callback) callback(surveyData);
    }
  };

  onCloseModal = () => {
    this.gotoAssessments();
    dispatch(highlightNavbarSection('history'));

    this.setState(
      {
        isShowModal: false
      },
      () => dispatch(getUserFromDBAndUpdateStore())
    );
  };

  renderPreConsent() {
    // Override sidebar then set it back
    const onClick = () => {
      this.setState({ isShowPreConsent: false }, () => {
        dispatch(highlightNavbarSection(null)); // Only happens if previsit
      });
    };
    const buttonProps = { onClick, fixed: "true" };

    dispatch(highlightNavbarSection('currentReport')); // Only happens if previsit

    const { classes } = this.props;

    return (
      <div className={classes.msgContainer}>
        <div className={classes.topContainer}>
          <br />
          <img
            src={ConfirmationIcon}
            className="titleImg"
            alt="upcoming visit"
          />

          <h4 className="greatTitle">
            {!this.props.isMobile ? (
              <span>Great! Your Visit Is Confirmed For:</span>
            ) : (
              <span>Your visit is scheduled for:</span>
            )}
          </h4>
          <h1 className={classes.upcomingVisit}>
            {this.props.upcomingVisit.longFormattedDate}
          </h1>
          <br />
          <br />
        </div>
        <Fragment>
          <div className={classes.bottomContainer}>
            <h4>
              Before your visit, we'll need to know more about your current
              health and medical history. In addition to providing you with a
              comprehensive health assessment, we invite you to take part in the
              Lab100 Research Repository.
            </h4>
            <br />
            <br />
            <br />
          </div>
          <Button {...buttonProps}> Begin </Button>
        </Fragment>
      </div>
    );
  }

  // consent done? show helpful tools. else show Next button then goto Consent

  render() {
    const { assessmentPage } = this.props.match.params;
    const { activeAssessment, activeAssessments } = this.props;
    const { shortName } = activeAssessment || {};

    const isConsentDone = true;

    let overridePage;

    if (assessmentPage) {
      const assessmentObj = find(activeAssessments[shortName].questions, {
        subRoute: { route: `/${assessmentPage}` }
      });
      if (assessmentObj) overridePage = assessmentObj.details.page;
    }

    let isOldVisit = true;
    if (this.props.upcomingVisit !== null && this.props.activeVisit !== null) {
      isOldVisit =
        this.props.upcomingVisit.uuid !== this.props.activeVisit.uuid;
    }

    const isNewAssessmentWithHistoryShowFinish =
      this.isNewAssessmentsWithHistory() &&
      activeAssessment.order === size(activeAssessments) - 1;

    const formProps = {
      survey: activeAssessment,
      gotoAssessments: () => this.gotoAssessments(),
      exitAssessments: () => this.props.changeRoute({ route: '/' }),
      isLoading: this.props.isAssessmentLoading,
      updateRoute: () => this.refreshAssessment(),
      overridePage,
      setProgressBarPercent: () => this.props.setProgressBarPercent(),
      isConsentDone,
      isMobile: this.props.isMobile,
      highlightedNavbarSection: this.props.highlightedNavbarSection,
      isNewAssessmentsWithHistory: this.isNewAssessmentsWithHistory(),
      isOldVisit,
      isNewAssessmentWithHistoryShowFinish,
      hasSubmittedConsent: isConsentDone
    };

    const { classes } = this.props;

    return (
      <div className={classes.base}>
        <Fragment>
          <div>
            <Survey editSurveyData={this.editSurveyData} {...formProps} />
          </div>
        </Fragment>
        {/* )} */}
        {/* <Outlet /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeVisit: state.containers.app.get('activeVisit'),
    currentVisit: state.containers.app.get('currentVisit'),
    upcomingVisit: state.containers.app.get('upcomingVisit'),
    pastVisits: state.containers.app.get('history'),
    user: state.containers.app.get('user'),
    activeAssessment: state.containers.app.get('activeAssessment'),
    activeAssessments: state.containers.app.get('activeAssessments'),
    highlightedNavbarSection: state.containers.nav.get(
      'highlightedNavbarSection'
    ),
    isMobile: state.containers.app.get('isMobile'),
    isAssessmentLoading: state.containers.assessment.get('isLoading')
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ setProgressBarPercent, changeRoute }, dispatch);
};

const withNavigationParams = Component => {
  return props => (
    <Component
      {...props}
      navigate={useNavigate()}
      match={{ params: { ...useParams() } }}
    />
  );
};

export default injectSheet(() => style)(
  connect(mapStateToProps, mapDispatchToProps)(withNavigationParams(Assessment))
);
